import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import * as XLSX from 'xlsx';
import { NavigationExtras, Router } from '@angular/router';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-upload-work-item-bsem',
  templateUrl: './upload-work-item-bsem.component.html',
  styleUrls: ['./upload-work-item-bsem.component.css']
})

export class UploadWorkItemBsemComponent implements OnInit {
  SetDocTypeDropDownValue :any;

  isOpenDoctypeModel: boolean = false;
  isOpenUploadTypeModel: boolean = false;

  docTypeList: { docTypeId: number, docTypeName: string }[] = [];

  selectedDocumentType: { docTypeId: number, docTypeName: string } = null;

  excelFileData: any;
  lstDocument = [];
  workItemFieldList = [];
  workItemFieldList_All = [];

  lstUploadData = [];
  lstDisplayData = [];
  lstDisplayField = [];
  lstHistoryData = [];

  browseMessage = "No file selected.";
  fileControlType = 'file';
  selectedExcelFile = this.browseMessage;
  fileTitle = "Choose file";

  invoiceFileType = "";
  supportingFileType = "";
  invoiceFileSize = "";
  supportingFileSize = "";

  selectedInvoiceFiles = this.browseMessage;
  selectedSupportingFiles = this.browseMessage;

  invoiceNumberDBColumnName = '';
  vendorNameDBColumnName = '';
  vendorCodeDBColumnName = '';

  selectedTab = 0;
  isValidated: boolean = false;
  loginVendorDetail: any;

  fileUploaded: File;
 uploadColumnsToHide: any = ['id', 'DOCUMENT_DETAIL_ID','FileId'];
  hyperLinkColumns:any=['total records','total no of sheets not uploaded','success','failure','duplicate'];
  @ViewChild('invFileUpload') fileInput: ElementRef;
  @ViewChild('invFileUpload1') fileInput1: ElementRef;
  @ViewChild('invFileUpload2') fileInput2: ElementRef;

  constructor(private commonService: CommonService,
    private dataService: DataService, private dialog: MatDialog, private route: Router,private encryptDecryptservice:EncryptDecryptService,private memorystore: MemoryStorageService
    ) {
  }

  ngOnInit(): void {
    this.getDocumentTypes();

  }
  getDocumentTypes() {
    this.docTypeList = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('subgroup_id',this.encryptDecryptservice.encryptUsingAES256( this.commonService.selectedSubgroup));
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService.getData('document-types', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          for (var i = 0; i < res.data.length; i++) {
            this.docTypeList.push({
              docTypeId: res.data[i].document_type_id,
              docTypeName: res.data[i].document_type_name,
            });
          }
          this.SetDocTypeDropDownValue = this.docTypeList[0].docTypeId;
          this.getFileHistory(this.docTypeList[0].docTypeId)
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },
    error => {
      if (error.includes("401")) {
        this.route.navigateByUrl('/unauthorized');
        return;
      }
    }
    );

  }

  getFileHistory(documentTypeID: any) {
    this.lstHistoryData = [];
    let params = new HttpParams();
    //params = params.append("DocumentTypeID", this.selectedDocumentType.docTypeId);
    params = params.append("DocumentTypeID", documentTypeID);
    params = params.append("ModuleName", "BSRECON");

    this.dataService.getData("uploadBSEM/uploadhistory/", params, this.dataService.apiURL_Core).subscribe(res => {
      //this.dataService.getData("invoice/uploadhistory", params, this.dataService.apiURL_Core).subscribe(res => {
      if (res.success == true) {
        res.data.forEach(row => {
          /* this.lstHistoryData.push({
            "Work Item Type": row.DocumentTypeName, "File Name": row.FileName, "Upload Date": row.CreatedDate,
            "Uploaded By": row.CreatedBy, Status: row.Status, "Total Records": row.TotalRecord, 'No Of Valid': row.NoOfValid,
            "No Of Invalid": row.NoOfInvalid, "No Of Duplicate": row.NoOfDuplicate
          }); */
          this.lstHistoryData.push({
            "S.No": row.SRNO, "File Name": row.FileName, "Total no of Sheets": row.TotalnoofSheets,
            "Total no of Sheets not Uploaded": row.TotalnoofSheetsnotUploaded,
            "Total Records": row.TotalRecords,
            "Success": row.Success, "Failure": row.Failure, "Duplicate": row.Duplicate,
            "Status": row.Status,
            "Upload Date": row.UploadedDate,
            "Uploaded By": row.UploadedBy,
            "FileId": row.FileId
          });
        });
      }
      else {
      }
    }, err => {
    });

  }



  downloadExcelTemplate() {

    if (this.selectedDocumentType == null || this.selectedDocumentType == undefined) {
      this.commonService.showMessageBox("Please select a Work item type.", "Alert");
      return
    }

    let lstFile = [];
    let obj = {};
    this.workItemFieldList.forEach(field => {
      if (field.control_type != "FILE") {
        obj[field.field_name] = '';
      }
    });

    obj["Invoice File Name"] = "";
    obj["Supporting File Name"] = "";

    lstFile.push(obj);

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(lstFile);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'LoadDataSheet');
    XLSX.writeFile(wb, this.selectedDocumentType.docTypeName + '_' + new Date().getTime() + '.xlsx');

  }

  onSelectExcelFile(file) {

    if (file.target.files[0].type.toLowerCase() != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      this.commonService.showMessageBox("Please select excel data file.", "Alert");
      this.fileInput.nativeElement.value = '';
      return;
    }

    this.selectedExcelFile = file.target.files[0].name;
    this.fileUploaded = file.target.files[0];

  }

  async uploadBulkInvoice() {
    if (this.selectedExcelFile == undefined) {
      this.commonService.showMessageBox("Please select excel data file.", "Alert");
      return;
    }
    let reader1 = new FileReader();
    reader1.onload = (e: any) => {
      let base64FileString = reader1.result.toString();
      let body = [];
      body.push({
        FileName: this.selectedExcelFile,
        FileData: base64FileString,
        DocumentTypeID: this.SetDocTypeDropDownValue,
        // CreatedBy: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
        // SubgroupID: (this.commonService.getUserInfoFromLocalStorage('subgroupId') == "null") ? 0 : Number(this.commonService.getUserInfoFromLocalStorage('subgroupId')),
        // RoleID: Number(this.commonService.getUserInfoFromLocalStorage('roleId')),
        // ProjectID: Number(this.commonService.getUserInfoFromLocalStorage('projectId')),
        CreatedBy: Number(this.memorystore.getItem('userId')),
        SubgroupID: (this.memorystore.getItem('subgroupId') == "null") ? 0 : Number(this.memorystore.getItem('subgroupId')),
        RoleID: Number(this.memorystore.getItem('roleId')),
        ProjectID: Number(this.memorystore.getItem('projectId')),
        Comment: '',
        IsBackgroudProcess: true,
        ModuleName: "BS RECON"
      });
      this.dataService.postData("uploadBSEM/uploadfile", body, this.dataService.apiURL_Core).subscribe(res => {
        if (res != null) {
          if (res.success == true) {
            this.getFileHistory(this.SetDocTypeDropDownValue);
            this.selectedExcelFile = this.browseMessage;
          }
          else {
            this.commonService.showMessageBox(res.errorMessage, "Alert");
          }
        }
      });
    };
    reader1.readAsDataURL(this.fileUploaded);
  }

  // Grid Data Event//
  advanceSearchCellClick(event: any) {

    if (event.columnName.toLowerCase() == 'total no of sheets not uploaded') {
      if (event.rowData["Total no of Sheets not Uploaded"] != '-') {
        this.getuploadDataintoexcel(event.rowData.FileId, "DOWNLOAD_SHEETISNOTUPLOADED")
      }
    }
    else if (event.columnName.toLowerCase() == 'total records') {
      if (event.rowData["Total Records"] != '-') {
        this.getuploadDataintoexcel(event.rowData.FileId, "DOWNLOAD_TOTALRECORDS")
      }
    }
    else if (event.columnName.toLowerCase() == 'success') {
      if (event.rowData["Success"] != '-') {
        this.getuploadDataintoexcel(event.rowData.FileId, "DOWNLOAD_SUCCESS")
      }
    }
    else if (event.columnName.toLowerCase() == 'failure') {
      if (event.rowData["Failure"] != '-') {
        this.getuploadDataintoexcel(event.rowData.FileId, "DOWNLOAD_ERROR")
      }
    }
    else if (event.columnName.toLowerCase() == 'duplicate') {
      if (event.rowData["Duplicate"] != '-') {
        this.getuploadDataintoexcel(event.rowData.FileId, "DOWNLOAD_DUPLICATE")
      }
    }
  }

  getuploadDataintoexcel(fileid: any, actionName: any) {
    this.lstUploadData = [];
    let params = new HttpParams();
    //params = params.append("DocumentTypeID", this.selectedDocumentType.docTypeId);
    params = params.append("DocumentTypeID", this.SetDocTypeDropDownValue);
    params = params.append("ModuleName", "BSRECON");
    params = params.append("ActionName", actionName);
    params = params.append("File_ID", fileid);
    this.dataService.getData("uploadBSEM/download/", params, this.dataService.apiURL_Core).subscribe(res => {
      if (res.success == true) {
        this.lstUploadData = res.data;
        if (this.lstUploadData.length > 0) {
          this.commonService.exportAsExcelFile(this.lstUploadData, actionName);
        }
      }
      else {
      }
    }, err => {
    });

  }

}
